import { useAuth0 } from '@auth0/auth0-react';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Loading from '../../components/loading';
import AuthContext from '../../providers/auth/auth-service';

const DEFAULT_PERMISSIONS = ['api_key_read', 'api_key_write'];

function arrayEquals(a: any[], b: any[]) {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  );
}

export default function LoginRedirect() {
  const { isAuthenticated, isLoading, getAccessTokenSilently, logout } = useAuth0();
  const navigate = useNavigate();

  const { login } = useContext(AuthContext);

  const checkPermissions = (permissions: string[]) => {
    if (permissions && permissions.length > 0 && !arrayEquals(permissions, DEFAULT_PERMISSIONS)) {
      navigate(
        '/login/redirect' === window.location.pathname ? '/dashboard' : window.location.pathname,
      );
    } else {
      navigate('/not-permission');
    }
  };

  useEffect(() => {
    async function checkUser() {
      if (isAuthenticated) {
        getAccessTokenSilently({ cacheMode: 'off' })
          .then(async (auth0Token) => {
            await login(auth0Token).then((response) => {
              if (response.data.permissions.length > 0) {
                checkPermissions(response.data.permissions);
              } else {
                console.error(response.data.message);
                logout({ logoutParams: { returnTo: import.meta.env.REACT_APP_AUTH0_LOGOUT } });
              }
            });
          })
          .catch((error) => {
            console.error(error);
            logout({ logoutParams: { returnTo: import.meta.env.REACT_APP_AUTH0_LOGOUT } });
          });
      }

      if (!isAuthenticated && !isLoading) {
        navigate('/login');
      }
    }

    checkUser();
  }, [isAuthenticated, isLoading]);

  return <Loading />;
}
